var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOrderArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 23,
    height: 15,
    rx: 7.5,
    stroke: "#EFF0FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 8h8M12.5 4.446L16.5 8l-4 3.556",
    stroke: "#191C1E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAyNSAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMSIgeT0iMC41IiB3aWR0aD0iMjMiIGhlaWdodD0iMTUiIHJ4PSI3LjUiIHN0cm9rZT0iI0VGRjBGQSIvPgo8cGF0aCBkPSJNOC41IDhMMTYuNSA4IiBzdHJva2U9IiMxOTFDMUUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTIuNSA0LjQ0NTUzTDE2LjUgOC4wMDEwOUwxMi41IDExLjU1NjYiIHN0cm9rZT0iIzE5MUMxRSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";
export { SvgOrderArrow as ReactComponent };